"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RedeemSectionPsnConfirmNext_1 = __importDefault(require("./RedeemSectionPsnConfirmNext"));
const RedeemSectionPsnCountryDropDown_1 = __importDefault(require("./RedeemSectionPsnCountryDropDown"));
const react_1 = __importDefault(require("react"));
const PsnCountryContainer = ({ enableRegionAutoDetection, externalAuths, countries, psnToolTip, psnCountry, connectedPlatforms }) => {
    if (enableRegionAutoDetection) {
        return react_1.default.createElement(RedeemSectionPsnConfirmNext_1.default, { externalAuths: externalAuths, connectedPlatforms: connectedPlatforms });
    }
    return react_1.default.createElement(RedeemSectionPsnCountryDropDown_1.default, { psnCountry: psnCountry, countries: countries, psnToolTip: psnToolTip });
};
exports.default = PsnCountryContainer;
//# sourceMappingURL=RedeemSectionPsnCountryContainer.js.map